import { Fragment } from 'react';
import { Violet500 } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { PaperFillIcon } from '@/icons';
import { AiButton, AiButtonIcon } from './AiButtonBase';
export const AiFileButton = ({
  onOpenBuildAiModal,
  isFull
}: {
  onOpenBuildAiModal: () => void;
  isFull: boolean;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <Fragment>
      <AiButton icon={<AiButtonIcon icon={<PaperFillIcon size={isFull ? 'sm' : 'xs'} fill={Violet500} />} />} label={t('build:ai.fileTab.title')} description={'pdf, csv, txt, docx, pptx, hwp'} size={isFull ? 'full' : 'simple'} onClick={onOpenBuildAiModal} data-sentry-element="AiButton" data-sentry-source-file="AiFileButton.tsx" />
    </Fragment>;
};